import { Component, Input, OnInit, Output, EventEmitter, DoCheck, OnDestroy, AfterViewInit } from '@angular/core';
import { CreateNewGroupDialogComponent } from '../Dialogs/create-new-group-dialog/create-new-group-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { Constant, DefaultGUID, DefaultTextMessageUTCDate, RoleName, SRGroupType } from 'src/app/@shared/constants/Constant';
import { IDeleteGroupModel, IGroupList, INewGroupModel, ISrListGroupList } from 'src/app/model/internalGroupChat.model';
import { ViewMemberModel } from 'src/app/service/memeber.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { InternalGroupChatService } from '../internal-group-chat.service';
import { SignalrService } from 'src/app/sse/signalr.service';
import { EventConstant } from 'src/app/sse/event.constant';
import { Subscription } from 'rxjs';
import { ServiceRequestStatusEnum } from '@enums/service-request-status.enum';

@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.css'],
})
export class ChatListComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {
  @Input('sRListGroupList') sRListGroupList: ISrListGroupList[];
  @Input('accessingFrom') accessingFrom: string;
  @Input('internalMemberList') internalMemberList: ViewMemberModel[];
  @Output('totalUnreadMessagesCount') totalUnreadMessagesCount = new EventEmitter();
  private _subscriptions: Subscription = new Subscription();
  public user: ILoggedInUserViewModel;
  public timeZone: any;
  public defaultTextMessageUTCDate: string = DefaultTextMessageUTCDate;
  public isAddNewGroupVisible: boolean;
  public showChatListForSmallScreen: boolean;
  public defaultGUID = DefaultGUID;
  public currentlyLoadedChatGroup: IGroupList;
  public chatGroupType = SRGroupType;
  public isShowChatTypeBadge: boolean;
  public readonly serviceRequestStatusEnum: typeof ServiceRequestStatusEnum = ServiceRequestStatusEnum;
  constructor(
    private _dialog: MatDialog,
    private _serviceRequestService: ServiceRequestService,
    private _internalGroupChatService: InternalGroupChatService,
    private _signalRService: SignalrService,
  ) {
    this._subscriptions.add(
      this._serviceRequestService.timZoneChange.subscribe((value) => {
        this.timeZone = Constant.selectedTimeZoneShortValue;
      }),
    );
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isAddNewGroupVisible =
      this.user.role === RoleName.ExecutiveAdmin || this.user.role === RoleName.Coordinator || this.user.role === RoleName.Management;
    this.isShowChatTypeBadge =
      this.user.role != RoleName.CustomerAdmin &&
      this.user.role != RoleName.CustomerCoordinator &&
      this.user.role != RoleName.VendorAdmin &&
      this.user.role != RoleName.VendorCoordinator &&
      this.user.role != RoleName.VendorDriver &&
      this.user.role != RoleName.Driver;
    this.EventListener();
    this._subscriptions.add(
      this._internalGroupChatService.updateGroupInfoAction.subscribe((response) => {
        if (response !== null && response.groupDetail.groupName !== null && response.groupDetail.groupName.trim().length > 0) {
          let serviceRequest: ISrListGroupList;
          serviceRequest = this.sRListGroupList?.filter(
            (serviceRequest) => serviceRequest.serviceRequestId === response.serviceRequestDetail.serviceRequestId,
          )[0];
          serviceRequest.groupLists.filter((group) => group.chatGroupId === response.groupDetail.chatGroupId)[0].groupName =
            response.groupDetail.groupName;
        }
      }),
    );
    this._subscriptions.add(
      this._internalGroupChatService.exitOrDeleteGroupAction.subscribe((response) => {
        if (response !== null && response.serviceRequestDetail && response.groupDetail) {
          let serviceRequest: ISrListGroupList;
          serviceRequest = this.sRListGroupList.find(
            (serviceRequest) => serviceRequest.serviceRequestId === response.serviceRequestDetail.serviceRequestId,
          );
          if (serviceRequest) {
            serviceRequest.groupLists = serviceRequest.groupLists?.filter(
              (group) => group.chatGroupId !== response.groupDetail.chatGroupId,
            );
            if (serviceRequest.groupLists.length === 0) {
              this.sRListGroupList = this.sRListGroupList?.filter((sr) => sr.serviceRequestId !== serviceRequest.serviceRequestId);
            }
          }
        }
      }),
    );
    this._subscriptions.add(
      this._internalGroupChatService.loadGroupChatAction.subscribe((response) => {
        if (response !== null) {
          if (response.groupDetail !== null && response.serviceRequestDetail !== null) {
            this.currentlyLoadedChatGroup = response.groupDetail;
          }
        }
      }),
    );
    this._subscriptions.add(
      this._internalGroupChatService.newMessageAction.subscribe((response) => {
        if (this.sRListGroupList && this.sRListGroupList.length > 0) {
          let groupChat = this.sRListGroupList
            .find((sr) => sr.serviceRequestId == response.serRequestId)
            ?.groupLists.find((groupChat) => groupChat.chatGroupId == response.chatGroupId);
          if (groupChat) {
            groupChat.unreadMessageCount++;
            groupChat.lastAttachmentType = response.messageData.attachmentType;
            groupChat.lastMessage = response.messageData.messageText;
            groupChat.lastMessageId = response.messageData.messageId;
            groupChat.lastMessageSender = response.messageData.memberName.split(' ')[0];
            groupChat.lastMessageSenderId = response.messageData.memberId;
            groupChat.lastMessageSentTime = response.messageData.messageSendTime;
            this.totalCountToShowOnHeader();
          }
        }
      }),
    );
  }

  ngDoCheck(): void {
    if (this.sRListGroupList) {
      if (this.sRListGroupList && this.sRListGroupList.length > 0) {
        this.totalCountToShowOnHeader();
      }
    }
  }

  ngAfterViewInit(): void {
    if (window.innerWidth <= 991) {
      this._subscriptions.add(
        this._internalGroupChatService.toggleBetweenChatListAndMessagePanelAction.subscribe((response) => {
          this.showChatListForSmallScreen = response === null || response === false;
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
    if (window.innerWidth <= 991) {
      this._internalGroupChatService.toggleBetweenChatListAndMessagePanelSubject$.next(false);
    }
  }

  EventListener() {
    if (this.user.role !== RoleName.InternalReadOnly) {
      this._signalRService.sseEventListener(EventConstant.createGroupEvent);
      this._signalRService.sseEventListener(EventConstant.deleteGroupEvent);
      this._subscriptions.add(
        this._signalRService.eventDataChange.subscribe(
          (value) => {
            switch (value.eventName) {
              case EventConstant.createGroupEvent:
                if (value.data as INewGroupModel) {
                  let serviceRequest: ISrListGroupList;
                  serviceRequest = this.sRListGroupList.find((serviceRequest) => serviceRequest.serviceRequestId === value.data.serReqId);
                  if (serviceRequest) {
                    if (serviceRequest.groupLists.find((group) => group.chatGroupId == value.data.chatGroupData.chatGroupId) == undefined) {
                      serviceRequest.groupLists.push(value.data.chatGroupData as IGroupList);
                    }
                  }
                }
                break;
              case EventConstant.deleteGroupEvent:
                if (value.data as IDeleteGroupModel) {
                  let sRDetail: ISrListGroupList = this.sRListGroupList.find(
                    (serviceRequest) => value.data.ServiceRequestId === serviceRequest.serviceRequestId,
                  );
                  let chatGroupDetail: IGroupList = sRDetail.groupLists.find((group) => group.chatGroupId === value.data.ChatGroupId);
                  this._internalGroupChatService.exitOrDeleteGroupSubject$.next({
                    serviceRequestDetail: sRDetail ? sRDetail : null,
                    groupDetail: chatGroupDetail ? chatGroupDetail : null,
                  });
                  if (this.currentlyLoadedChatGroup.chatGroupId === value.data.ChatGroupId) {
                    this._internalGroupChatService.loadGroupChatSubject$.next({
                      serviceRequestDetail: null,
                      groupDetail: null,
                    });
                  }
                }
                break;
            }
          },
          (error) => {
            console.log(error);
          },
        ),
      );
    }
    return null;
  }

  openCreateNewGroupDialog(serviceRequest: ISrListGroupList) {
    const dialogRef = this._dialog.open(CreateNewGroupDialogComponent, {
      maxWidth: '80rem',
      width: '100%',
      minWidth: '21rem',
      data: {
        serviceRequest: serviceRequest,
        internalMemberList: this.internalMemberList,
      },
      height: 'fit-content',
    });
    this._subscriptions.add(
      dialogRef.afterClosed().subscribe((response: IGroupList | string) => {
        if (response && response !== '') {
          if (serviceRequest.groupLists.find((group) => group.chatGroupId == (response as IGroupList).chatGroupId) == undefined) {
            serviceRequest.groupLists.push(response as IGroupList);
          }
        }
      }),
    );
  }

  totalUnreadMessageCount(groupList: IGroupList[]) {
    let totalCount: number = 0;
    groupList.map((group) => {
      totalCount += group.unreadMessageCount;
    });
    return totalCount;
  }

  totalCountToShowOnHeader() {
    let totalCount: number = 0;
    this.sRListGroupList.map((response) => {
      totalCount += this.totalUnreadMessageCount(response.groupLists);
    });
    this.totalUnreadMessagesCount.emit(totalCount.toString());
  }

  openMessagePage(serviceRequestDetail: ISrListGroupList, groupDetail: IGroupList) {
    this._internalGroupChatService.loadGroupChatSubject$.next({
      serviceRequestDetail: serviceRequestDetail,
      groupDetail: groupDetail,
    });

    if (window.innerWidth <= 991) {
      this._internalGroupChatService.toggleBetweenChatListAndMessagePanelSubject$.next(true);
    }
  }
}
